const mapToSelect = (name) => ({
  value: name,
  label: name
});

export default mapToSelect;
